// @flow

import React, { type Node } from 'react';
import { PaymentInfo } from './payment-info';
import { ExpirationDateTime } from '../../../commons';


export function DisplayExpiration(): Node {
  return (
    <PaymentInfo label="Pague até:" >
      <ExpirationDateTime />
    </PaymentInfo>
  );
}
